import { Button, Container, Grid, Paper, Typography, useTheme } from "@mui/material";
import CustomBreadcrumbs from "../../../components/breadcrumbs";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useHistory } from "react-router-dom";
import CategoriesDataTable from "./table";
import SectionTitle from "../../../components/sectionTitle";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export default function Categories()
{
    const theme = useTheme();

    useEffect(()=>{
        window.scrollTo(0,0);
    });
    
    const history = useHistory();

    const redirect = (route) => {
        history.push(route)
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs returnTo='/products' crumbs={[{name:'Categorías',link:'/categories'}]}/>
            <br/>
            <SectionTitle title='Categorías'/>
            <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12} lg={8}>
                    <Paper elevation={3} style={{padding:15,backgroundColor:'#ebf9ff'}}>
                        <Grid container alignContent={'center'} justifyContent={'center'}>
                            <Grid item xs={12} lg={1} textAlign={'center'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                <FontAwesomeIcon icon={faInfoCircle} size='2x' color={theme.palette.link.main}/>
                            </Grid>
                            <Grid item xs={12} lg={11}>
                               <Typography variant="h6" color={theme.palette.link.main} gutterBottom>
                                    ¿Qué son las Categorías?
                                </Typography>
                                <Typography variant="body1" color={theme.palette.text.secondary} gutterBottom>
                                    Las Categorías son las secciones principales de tu catalogo de productos. Piensa en ellas 
                                    como los pasillos de un supermercado o los departamentos de una tienda.
                                    Te permiten agrupar tus productos para que tus clientes puedan encontrar lo que buscan de forma rápida e intuitiva.
                                    <br/>- Ejemplos (Restaurante): "Entradas", "Platos Fuertes", "Bebidas", "Postres".
                                    <br/>- Ejemplos (Ropa): "Camisas", "Pantalones", "Calzado", "Accesorios".
                                    <br/>- Ejemplos (Servicios): "Masajes Terapéuticos", "Tratamientos Faciales", "Consultorías".
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} lg={12} mt={5}>
                    <Button
                        mt={5}
                        variant='contained'
                        endIcon={<AddCircleIcon/>}
                        onClick={()=>redirect('categories/add')}
                    >
                        <Typography>Categorías</Typography>
                    </Button>
                </Grid>
            </Grid>
            <br/>
            <CategoriesDataTable/>
        </Container>
    )
}